import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  i18n: {
    componentheading: '',
    deliveryscopeheading: '',
    resultlistheading: '',
    sizeheading: '',
    weightheading: '',
    weightlabel: '',
    maxweightlabel: '',
    maxmeasurementlabel: '',
    senddirectcta: '',
    stampshopcta: '',
    message: '',
    servicePointHeader: '',
    servicePointLink: '',
    realPostcard: '',
    realPostcardMobile: '',
    ombudHeader: '',
    noResultMessage: '',
    clearFilterButton: '',
    countryToSendTo: '',
    smallPackage: '',
    mediumPackage: '',
    largePackage: '',
    personComparison: '',
    cloudsImage: '',
  },
  market: {
    currency: '',
    country: '',
    servicePoint: '',
  },
});

export { state, onChange };
export default state;
